export class MenuController {
    constructor() {
        this._menuBlock = document.querySelector('#menu');
        this._shareBlock = document.querySelector('.share');
    }

    init() {
        this._menuBlock.addEventListener('click', () => {
            this._shareBlock.classList.toggle('active');
        });
    }
}
